var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioLoadingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "currentColor",
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    className: "ant-sender-actions-btn-recording-icon",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Speech Recording") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#1890ff",
    rx: 70,
    ry: 70,
    height: 250,
    width: 140,
    x: 0,
    y: 375
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "250; 500; 250",
    keyTimes: "0; 0.5; 1",
    dur: "0.8s",
    begin: "0s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "375; 250; 375",
    keyTimes: "0; 0.5; 1",
    dur: "0.8s",
    begin: "0s",
    repeatCount: "indefinite"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#1890ff",
    rx: 70,
    ry: 70,
    height: 250,
    width: 140,
    x: 286.67,
    y: 375
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "250; 500; 250",
    keyTimes: "0; 0.5; 1",
    dur: "0.8s",
    begin: "0.2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "375; 250; 375",
    keyTimes: "0; 0.5; 1",
    dur: "0.8s",
    begin: "0.2s",
    repeatCount: "indefinite"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#1890ff",
    rx: 70,
    ry: 70,
    height: 250,
    width: 140,
    x: 573.33,
    y: 375
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "250; 500; 250",
    keyTimes: "0; 0.5; 1",
    dur: "0.8s",
    begin: "0.4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "375; 250; 375",
    keyTimes: "0; 0.5; 1",
    dur: "0.8s",
    begin: "0.4s",
    repeatCount: "indefinite"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#1890ff",
    rx: 70,
    ry: 70,
    height: 250,
    width: 140,
    x: 860,
    y: 375
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "250; 500; 250",
    keyTimes: "0; 0.5; 1",
    dur: "0.8s",
    begin: "0.6s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "375; 250; 375",
    keyTimes: "0; 0.5; 1",
    dur: "0.8s",
    begin: "0.6s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioLoadingIcon);
export default __webpack_public_path__ + "static/media/audioLoadingIcon.95203aecd7a3f4197703207124d2b846.svg";
export { ForwardRef as ReactComponent };